import { HateoasResource } from "@lagoshny/ngx-hateoas-client";
import { BaseEntity } from "@app/models/rest/base-entity";
import { ResourceFactMappingPattern } from "./resource-fact-mapping-pattern";

@HateoasResource("resourceFactMappingPatternEntries")
export class ResourceFactMappingPatternEntry extends BaseEntity {
  offsetDay: number;
  startOffsetHour: number;
  startOffsetMinute: number;
  duration: number;
  mappingPattern: ResourceFactMappingPattern;
}
